// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container .divLine[data-v-af59d86e] {\n  font-size: 0.15rem;\n  color: #000;\n  margin-bottom: 0.05rem;\n  display: flex;\n  align-items: center;\n}\n.container .divLine span[data-v-af59d86e] {\n    font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
